var render = function render(){var _vm=this,_c=_vm._self._c;return _c('BaseModal',_vm._g(_vm._b({attrs:{"name":"project-list-edit","width":400,"toptitle":"Verteiler bearbeiten","title":_vm.projectList.name}},'BaseModal',_vm.$attrs,false),_vm.$listeners),[_c('project-list-form',{attrs:{"projectList":_vm.projectList,"type":"edit"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }